import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "What Are Ramadan Goals Explained",
        content: "Discover key objectives of Ramadan and how to grow during this blessed month.",
        details: {
            date: "22 March, 2025",
            time: "10:00 AM - 02:00 PM",
            location: "Dublin, Ireland",
            organizer: "Islamic Learning Center",
            number: "+92-300-1234567",
            email: "info@islamiclearning.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us for an enlightening session exploring the true purpose and goals of Ramadan. This event will cover the spiritual, social, and personal development aspects of fasting and worship during the holy month.",
            "Gain valuable insights from renowned scholars, participate in interactive discussions, and learn practical tips to maximize your spiritual growth during Ramadan."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2
        ],
        highlights: [
            "Keynote speech on the significance of Ramadan.",
            "Interactive Q&A session with scholars.",
            "Guided reflections on Quranic verses related to fasting.",
            "Practical strategies for achieving Ramadan goals.",
            "Community networking and refreshments."
        ],
        essentials: [
            "Notebook and Pen for Notes",
            "An Open Heart and Mind",
            "Questions for Scholars",
            "Respect for Cultural and Religious Etiquette"
        ],
        guestIds: [1, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 2,
        image: images.event2,
        title: "Tafseer of Quran Study Session",
        content: "Explore the meanings of Quranic verses and understand their relevance in life.",
        details: {
            date: "29 March, 2025",
            time: "4:00 PM - 7:00 PM",
            location: "Dublin, Ireland",
            organizer: "Quran Study Circle",
            number: "+92-321-9876543",
            email: "info@quranstudycircle.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Delve deep into the meanings of the Holy Quran with this insightful Tafseer session. Learn the historical context, linguistic beauty, and practical applications of selected Surahs.",
            "This session is guided by experienced scholars who will provide detailed explanations, encourage questions, and help participants strengthen their understanding of the Quran."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2
        ],
        highlights: [
            "In-depth Tafseer of selected Surahs.",
            "Explanation of Quranic language and grammar.",
            "Historical and cultural context of revelations.",
            "Interactive Q&A with scholars.",
            "Practical lessons for modern life."
        ],
        essentials: [
            "Personal Copy of the Quran",
            "Notebook for Key Points",
            "Questions to Clarify Concepts",
            "Respect for Learning Environment"
        ],
        guestIds: [2, 3],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 3,
        image: images.event3,
        title: "How to Achieve Happiness Easily",
        content: "Learn simple ways to find lasting happiness and peace in life.",
        details: {
            date: "10 April, 2025",
            time: "5:00 PM - 8:00 PM",
            location: "Dublin, Ireland",
            organizer: "Positive Living Academy",
            number: "+92-300-4567891",
            email: "contact@positiveliving.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Discover the simple yet powerful steps to living a happier life in this interactive workshop. Learn how small changes in mindset, habits, and relationships can create lasting joy.",
            "Led by personal development experts, this session offers real-life strategies, practical exercises, and inspiring stories to help you find contentment and peace in everyday life."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2
        ],
        highlights: [
            "Key principles of happiness backed by science.",
            "Daily habits that boost emotional well-being.",
            "Mindfulness and gratitude techniques.",
            "Overcoming stress and negativity.",
            "Creating a personal happiness plan."
        ],
        essentials: [
            "Notebook for Practical Exercises",
            "Comfortable Clothing for Relaxation",
            "Positive Mindset for Learning",
            "Willingness to Try New Habits"
        ],
        guestIds: [4, 1],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 4,
        image: images.event4,
        title: "Depression and Mental Health Awareness",
        content: "Understand the link between faith and mental health for a lifestyle.",
        details: {
            date: "20 May, 2025",
            time: "4:00 PM - 7:00 PM",
            location: "Dublin, Ireland",
            organizer: "Mind Wellness Foundation",
            number: "+92-321-9876543",
            email: "support@mindwellness.org",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us for an insightful seminar focusing on depression, anxiety, and the importance of mental health awareness. This event aims to break the stigma, provide educational resources, and encourage open conversations about mental well-being.",
            "Expert psychologists, therapists, and advocates will share their knowledge on recognizing symptoms, accessing help, and building a supportive community for those affected."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2
        ],
        highlights: [
            "Expert talks on mental health and depression.",
            "Guidance on coping strategies and self-care.",
            "Information on local mental health resources.",
            "Real-life stories of recovery and resilience.",
            "Interactive Q&A session with mental health professionals."
        ],
        essentials: [
            "Notebook for Key Insights",
            "Openness to Discuss Mental Health",
            "Contact Details for Follow-up Support",
            "Willingness to Help Others in Need"
        ],
        guestIds: [4, 3],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.event5,
        title: "Islamic Traits of Leadership Skills",
        content: "Develop strong Islamic leadership qualities to inspire your community.",
        details: {
            date: "28 June, 2025",
            time: "3:00 PM - 6:00 PM",
            location: "Dublin, Ireland",
            organizer: "Islamic Leadership Institute",
            number: "+92-300-7654321",
            email: "info@islamicleadership.org",
            fee: "Free Admission"
        },
        paragraphs: [
            "This event explores the principles of leadership in Islam, drawing from the teachings of the Quran, Sunnah, and the exemplary leadership qualities of the Prophet Muhammad (PBUH). Attendees will gain a deeper understanding of how Islamic values shape effective leadership in personal, professional, and community life.",
            "Through engaging lectures and interactive discussions, scholars and leadership experts will highlight key traits such as justice, humility, consultation (Shura), trustworthiness, and service to others."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2
        ],
        highlights: [
            "Insights into leadership qualities from the Quran and Sunnah.",
            "Case studies from the lives of Islamic leaders.",
            "Practical guidance on applying Islamic leadership traits today.",
            "Interactive discussion on Shura and decision-making.",
            "Networking with community leaders and scholars."
        ],
        essentials: [
            "Notebook and Pen for Notes",
            "Open Mindset for Learning",
            "Respect for Islamic Teachings",
            "Interest in Leadership Development"
        ],
        guestIds: [1, 3],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 6,
        image: images.event6,
        title: "Anger Management Techniques Guide",
        content: "Gain effective strategies to control anger in challenging situations.",
        details: {
            date: "27 October, 2025",
            time: "2:00 PM - 6:00 PM",
            location: "Dublin, Ireland",
            organizer: "Mind Wellness Center",
            number: "+92-300-9876543",
            email: "info@mindwellness.org",
            fee: "Free Admission"
        },
        paragraphs: [
            "This workshop provides practical strategies and Islamic perspectives for managing anger effectively. Attendees will learn to identify triggers, control emotional responses, and apply patience and mindfulness techniques to daily life.",
            "Through expert talks, role-play activities, and real-life case discussions, participants will leave with actionable tools to handle anger constructively and improve personal and professional relationships."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2
        ],
        highlights: [
            "Identifying personal anger triggers.",
            "Techniques for staying calm under pressure.",
            "Islamic teachings on patience and self-control.",
            "Role-playing for conflict resolution.",
            "Mindfulness practices for daily life."
        ],
        essentials: [
            "Notebook and Pen",
            "Comfortable Clothing",
            "Willingness to Participate",
            "Openness to Self-Reflection"
        ],
        guestIds: [4, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    }

];

export default events;